import { fileNames } from "../Constants/imageUrls";
import { SITECODES } from "../Constants/siteCodes";
export var getIcon = function getIcon(siteCode) {
  if (siteCode === SITECODES.OLXTR) {
    return fileNames.MAP_OTOPLUS_ICON_PIN;
  }
  if (siteCode === SITECODES.OLXPL) {
    return fileNames.MAP_321SPRZEDANE_ICON_PIN;
  }
  return fileNames.MAP_ICON_PIN;
};
export var getDefaultMapIcon = function getDefaultMapIcon(sitecode) {
  var mobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (sitecode === SITECODES.OLXTR) {
    if (mobile) {
      return fileNames.MAP_DEFAULT_MOBILE_OTOPLUS_ICON;
    }
    return fileNames.MAP_DEFAULT_OTOPLUS_ICON;
  }
  if (mobile) {
    return fileNames.MAP_DEFAULT_MOBILE_ICON;
  }
  return fileNames.MAP_DEFAULT_ICON;
};
export var baseSize = {
  width: 52,
  height: 45
};
export var defaultZoom = 6;